// extracted by mini-css-extract-plugin
export var lookForwardDescription = "careers-module--look-forward-description--6104f";
export var lookForwardTitle = "careers-module--look-forward-title--e65f0";
export var lookForwardWrapper = "careers-module--look-forward-wrapper--e363e";
export var sidebarInfoButton = "careers-module--sidebar-info-button--4288a";
export var sidebarInfoText = "careers-module--sidebar-info-text--4ad3b";
export var sidebarInfoWrapper = "careers-module--sidebar-info-wrapper--41624";
export var sidebarSocialLinks = "careers-module--sidebar-social-links--27448";
export var subscribeWrapper = "careers-module--subscribe-wrapper--625a4";
export var title = "careers-module--title--30381";